import { apolloHooks } from '@nxte-nl/apollo-hooks';

import { sendProposalRequestMutation } from '../../../mutations/sendProposalRequest.gql';
import { BaseResponse } from '../../../types/apiCompoundCommon';
import { MutationsendProposalRequestArgs, ProposalResponseData } from '../../../types/apiTypes';
import { apolloMiddlewareHooks } from '../../apolloMiddlewareHooks/apolloMiddlewareHooks';
import { helperHooks } from '../helperHooks/helperHooks';

export type SendProposalRequestVariables = Omit<MutationsendProposalRequestArgs, 'userData'>;
export type SendProposalRequestResponse = BaseResponse<ProposalResponseData>;

export const sendProposalRequestHooks = {
  useSendProposalRequestMutation(
    onOpenSuccessModal: () => void,
  ) {
    const defaultErrorMiddleware = apolloMiddlewareHooks.useDefaultErrorMiddleware();

    const handleResponse = helperHooks
      .useHandleResponseWithoutData<ProposalResponseData>(onOpenSuccessModal);

    const [mutate, { loading }] = apolloHooks.useMutation<
    SendProposalRequestResponse, SendProposalRequestVariables>(sendProposalRequestMutation, {
      onCompleted: handleResponse,
      context: {
        middleware: defaultErrorMiddleware,
      },
    });

    return {
      loading,
      mutate,
    };
  },
};
